import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between gap-3 py-1" }
const _hoisted_2 = { class: "text-xs text-dashboard-muted flex-shrink-0 pt-0.5" }
const _hoisted_3 = { class: "text-sm text-dashboard-text text-right min-w-0 max-w-[70%]" }


export default /*@__PURE__*/_defineComponent({
  __name: 'KV',
  props: {
    label: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})